import axios from 'axios';
import Vue from 'vue';
import i18next from 'i18next';
import LogRocket from 'logrocket';
import smartlookClient from 'smartlook-client';

export default {
  doLogin({ commit }, creds) {
    commit('startLogin'); // show spinner
    return new Promise((resolve, reject) => {
      const l = `${creds.serverprotocol}//${creds.serveraddr}:${creds.serverport}`;
      // const l = `${location.protocol}//${location.hostname}:5108`
      axios
        .post(`${l}/rest/login`, { username: creds.username,
          password: creds.encodedPassword,
          authkey: creds.authKey,
          tfapassword: creds.tfaPassword })
        .then(response => {
          if (response.data.Success) {
            localStorage.setItem('lastcredsprotocol', creds.serverprotocol);
            localStorage.setItem('lastcredsserver', creds.serveraddr);
            localStorage.setItem('lastcredsport', creds.serverport);
            localStorage.setItem('token', encodeURIComponent(response.data.Authkey));
            localStorage.setItem('server', l);
            localStorage.setItem('licenceowner', response.data.LicenceOwner);
            localStorage.setItem('serverversion', response.data.Version);
            localStorage.setItem('serverbuild', response.data.Build);
            localStorage.setItem('serverGuid', response.data.ServerGuid);

            const loginParams = { server: creds.serveraddr, port: creds.serverport, protocol: creds.serverprotocol };
            localStorage.setItem('loginParams', JSON.stringify(loginParams));
            localStorage.setItem('username', creds.username);

            commit('loginSuccess');
            commit('clearData');
            // console.log('Start get all settings');
            // this.dispatch('getSettings').then(resolve);
            // console.log('Started get all settings');
          } else {
            commit('loginFailure', 'Login Failure');
          }
        })
        .catch(e => {
          commit('loginFailure', 'Login Failure ' + e.message);
          reject(e);
        });
    });
  },
  logout({ commit }, logoutReason) {
    console.log('Do Logout ', logoutReason);
    localStorage.removeItem('token');
    localStorage.removeItem('server');
    localStorage.removeItem('wsserver');
    localStorage.removeItem('licenceowner');
    localStorage.removeItem('serverversion');
    localStorage.removeItem('serverbuild');
    localStorage.removeItem('serverGuid');

    axios.defaults.headers.common['Authorization'] = undefined;
    commit('logout', logoutReason);
  },
  getFolders({ state, commit }) {
    console.log('get folders');
    axios
      .get(`/rest/user/folders`)
      .then(d => {
        console.log('got folders');
        commit('setFolders', d.data.folders);
      })
      .catch(e => {
        console.log(e);
        console.log('Get folders failed - logout');
        commit('logout');
      })
      .finally(() => {
        console.log('end get folders');
      });
  },
  getCollectedAddresses({ state, commit }) {
    console.log('get collected addresses');
    axios
      .get(`/rest/user/addresses/collected`)
      .then(d => {
        console.log('got collected addresses', d);
        console.log('addrs3', Object.keys(d.data.addresses).length);
        // gAddresses = d.data.addresses;
        commit('setCollectedAddresses', d.data.addresses);
      })
      .catch(e => {
        console.log(e);
        console.log('Get collected addresses failed');
      });
  },
  getAddressBook({ state, commit }) {
    console.log('get address book');
    axios
      .get(`/rest/user/addresses/scopes`)
      .then(d => {
        console.log('got address book scopes', d);
        commit('setAddressBookScopes', d.data.scopes);
      })
      .catch(e => {
        console.log(e);
        console.log('Get address book scopes failed');
      });
    axios
      .get(`/rest/user/addresses/entries`)
      .then(d => {
        console.log('got address book entries', d);
        commit('setAddressBookEntries', d.data.entries);
      })
      .catch(e => {
        console.log(e);
        console.log('Get address book entries failed');
      });
  },
  updateAddrBookEntry({ commit }, { dn, entry }) {
    return new Promise((resolve, reject) => {
      axios.put(`/rest/user/addresses/entries/${dn}`, entry)
        .then(d => {
          console.log('saved', d);

          commit('updateAddrBookEntry', { dn, entry: d.data.entry });
          resolve();
        })
        .catch(e => {
          console.log(e);
          reject(e);
        });
    });
  },
  deleteAddrBookEntry({ commit }, { dn }) {
    return new Promise((resolve, reject) => {
      axios.delete(`/rest/user/addresses/entries/${dn}`)
        .then(d => {
          commit('deleteAddrBookEntry', { dn });
          resolve();
        })
        .catch(e => {
          console.log(e);
          reject(e);
        });
    });
  },
  createAddrBook({ commit }, { name }) {
    return new Promise((resolve, reject) => {
      axios.post('/rest/user/addresses/scopes', { name })
        .then(d => {
          commit('addAddressBookScope', d.data.scope);
          resolve(d.data.scope.dn);
        })
        .catch(e => {
          console.log(e);
          reject(e);
        });
    });
  },
  deleteAddrBook({ commit }, { dn }) {
    return new Promise((resolve, reject) => {
      axios.delete(`/rest/user/addresses/scopes/${dn}`)
        .then(d => {
          commit('deleteAddressBookScope', dn);
          resolve(dn);
        })
        .catch(e => {
          console.log(e);
          reject(e);
        });
    });
  },
  createAddrEntry({ commit }, { scope, entry }) {
    return new Promise((resolve, reject) => {
      axios.post('/rest/user/addresses/entries', { scope, entry })
        .then(d => {
          commit('updateAddrBookEntry', { dn: d.data.entry.dn, entry: d.data.entry });
          resolve(d.data.entry.dn);
        })
        .catch(e => {
          console.log(e);
          reject(e);
        });
    });
  },
  getSettings({ state, commit }) {
    console.log('get settings');
    axios
      .get(`/rest/user/settings`)
      .then(d => {
        console.log('got settings', d);
        commit('setSettings', d.data);
      })
      .catch(e => {
        console.log(e);
        console.log('Get settings failed - logout');
        commit('logout');
      })
      .finally(() => {
        console.log('end get settings');
      });
  },
  setSetting({ state, commit }, { name, value }) {
    axios.patch('/rest/user/settings', { [name]: value })
      .then(d => {
        commit('patchSettings', { patch: d.data });
      })
      .catch(e => {
        console.log(e);
        console.log('Patch settings failed');
        Vue.$dialog.alert(this.$t('messageView.loadError', { error: e.message }));
      });
  },
  setFavouriteFolder({ state, dispatch }, { name, value }) {
    let favouriteFolders = [...state.settings.favouritefolders];
    if (value) {
      if (favouriteFolders.indexOf(name) === -1) {
        favouriteFolders.push(name);
      }
    } else {
      const i = favouriteFolders.indexOf(name);
      if (i !== -1) {
        favouriteFolders.splice(i, 1);
      }
    }
    dispatch('setSetting', { name: 'favouritefolders', value: favouriteFolders });
  },
  moveFavouriteFolderUp({ getters, dispatch }, { name }) {
    let favouriteFolders = [...getters.favouriteFolders];
    const i = favouriteFolders.indexOf(name);
    if ((i !== -1) && (i !== 0)) {
      favouriteFolders.splice(i, 1);
      favouriteFolders.splice(i - 1, 0, name);
    }
    dispatch('setSetting', { name: 'favouritefolders', value: favouriteFolders });
  },
  moveFavouriteFolderDown({ getters, dispatch }, { name }) {
    let favouriteFolders = [...getters.favouriteFolders];
    const i = favouriteFolders.indexOf(name);
    if ((i !== -1) && (i !== favouriteFolders.length - 1)) {
      favouriteFolders.splice(i, 1);
      favouriteFolders.splice(i + 1, 0, name);
    }
    dispatch('setSetting', { name: 'favouritefolders', value: favouriteFolders });
  },
  toggleCalendar({ state, dispatch }, { calendarId }) {
    let calendars = state.settings.selectedcalendars;
    if (calendars[calendarId]) {
      delete calendars[calendarId];
    } else {
      calendars[calendarId] = true;
    }
    dispatch('setSetting', { name: 'selectedcalendars', value: calendars });
  },
  addAllowedImageSender({ commit }, { addr }) {
    axios
      .put(`/rest/user/addresses/collected/${addr}`, { allowimages: true })
      .then(d => {
        commit('addAllowedImageSender', { id: d.data[addr].id, sender: addr });
      });
  },
  setLanguage({ commit }, { language }) {
    i18next.changeLanguage(language);
    commit('setLanguage', { language });
  },
  enableSentry({ commit }, enable) {
    commit('setSentry', enable);
  },
  enableInternalTrack({ commit }, enable) {
    commit('setInternalTrack', enable);
  },
  enableLogRocket({ state, commit }, enable) {
    if (enable) {
      if (!state.logrocketInitialised) {
        LogRocket.init('9djayc/vpop3-webmail', {
          release: '0.0.1',
          dom: {
            textSanitizer: true
          }
        });
        commit('setLogRocket', enable);
      }
      LogRocket.identify(`${state.username}@${localStorage.getItem('licenceowner')}`);
    }
  },
  enableSmartLook({ state, commit }, enable) {
    if (!state.smartlookInitialised) {
      smartlookClient.init('f5146e5b1d4210dc3dbd7a996dfd062ce266282f');
      commit('setSmartLook', enable);
    }
  }
};
